export default __webpack_public_path__ + "static/media/Mail1.c65ee696.svg";